export default (product) => ({
  discountPercentage: 0,
  klevuHandle: null,
  name: product?.name?.split(" / ")[0],
  price: null,
  recommendedPrice: null,
  onSale: false,
  currency: null,
  tags: (product?.tags || "").split(", "),
  isOutfit: (product?.tags || "").includes("outfit"),
  topTag: {
    text: null,
    classes: null,
  },
  product: product,
  // IMAGE SETTINGS
  IS: {
    load: null,
    fetchPriority: null,
    title: null,
    showSecondaryImg: null,
    firstImage: null,
    secondImage: null,
    thumbnail: null,
    imgList: [],
    newPacshot: null,
    overrideImgNumber: null,
    flatlay: null,
    filename: null,
    specialImage: null,
    overrideImgNumber: null,
    firstImageName: null,
    firstImageOverride: null,
    firstImageCheck: "_001.",
  },

  init() {
    const { discount, price, salePrice } = this.product;
    this.price = this.formatPrice(salePrice);
    this.recommendedPrice = this.formatPrice(price);

    const discountFloat = parseFloat(discount ?? "0");
    const salePriceFloat = parseFloat(salePrice ?? "0");
    const priceFloat = parseFloat(price ?? "0");

    if (salePrice && price && salePriceFloat < priceFloat) {
      this.onSale = true;

      try {
        const discountPercentage = (discountFloat / priceFloat) * 100;
        this.discountPercentage = discountPercentage.toFixed(0);
      } catch (error) {
        console.log(error);
      }
    }

    const url = new URL(product.url);
    const paths = url.pathname.split("/");
    this.klevuHandle = paths.pop();

    this.setImages();
    this.setTopTag();
  },

  setImages() {
    const product = this.product;
    this.IS.imgList = product.media.split(",");

    this.IS.load = "lazy";
    this.IS.fetch = "auto";
    this.IS.title = product.name;

    // Default images
    this.IS.firstImageName = "_003.";
    this.IS.firstImage = product.image;
    this.IS.secondImage = this.IS.imgList[1];
    this.IS.showSecondaryImg = this.IS.imgList[1] ? true : false;
    this.IS.newPacshot = false;

    if (product.tags.includes("pacshot_new")) {
      this.IS.newPacshot = true;
    }

    // Preload the first image for faster LCP
    const preloadImage = new Image();
    preloadImage.src =
      this.IS.firstImage.replace("_medium", "") + "&width=1200";
    document.head.appendChild(preloadImage); // Appends preload tag for the first image

    // Override featured image from metafield
    this.IS.overrideImgNumber = product.featuredimageoverride;
    if (
      this.IS.overrideImgNumber &&
      this.IS.overrideImgNumber != "No override"
    ) {
      this.IS.firstImageName = this.IS.overrideImgNumber;

      // If override image is '_001.' set boolean for secondImage
      if (this.IS.firstImageName == "_001.") {
        this.IS.firstImageOverride = true;
      }
    }

    // Overrida according to image rules
    // !! IMPORTANT !! NEW DATA --> use this.IS.imgList instead of const imgList
    //const imgList = [this.IS.firstImage, this.IS.secondImage];

    this.IS.imgList.forEach((img) => {
      const splitImg = img.split("/");
      const filename = splitImg[splitImg.length - 1];

      if (filename.includes(this.IS.firstImageName)) {
        this.IS.firstImage = img;
      }

      if (filename.includes("_001.")) {
        this.IS.secondImage = img;
        this.IS.specialImage = true;
      }

      // Override image is '_001.' - set secondImage to first available image which is not '_001.'
      if (this.IS.firstImageOverride) {
        if (filename.includes("_001.")) {
          this.IS.secondImage = img;
          this.IS.specialImage = true;
          return;
        } else {
          if (filename.includes("_001.")) {
            this.IS.secondImage = img;
            this.IS.specialImage = true;
          }
        }
      }
    });

    if (this.IS.firstImageOverride) {
      if (this.IS.imgList.length == 2) {
        if (this.IS.firstImage.includes("_001.")) {
          this.IS.secondImage = this.IS.imgList[1];
          this.IS.firstImageCheck = false;
        }
      }
    }

    if (this.IS.firstImage == this.IS.secondImage) {
      //this.IS.showSecondaryImg = false;

      // if not second image is selected, set a hover image
      if (this.IS.firstImage.includes(this.IS.imgList[0])) {
        this.IS.secondImage = this.IS.imgList[1];
      } else {
        this.IS.secondImage = this.IS.imgList[0];
      }
    }

    if (this.IS.flatlay) {
      this.IS.showSecondaryImg = false;
      if (this.IS.secondImage.includes("_001.")) {
        this.IS.firstImage = this.IS.secondImage;
        this.IS.specialImage = true;
      }
    }

    let imgWidth = window.innerWidth > 639 ? "&width=1200" : "&width=500";
    this.IS.firstImage = this.IS.firstImage.replace("_medium", "") + imgWidth;
    if (this.IS.secondImage) {
      this.IS.secondImage =
        this.IS.secondImage.replace("_medium", "") + imgWidth;
    }
    this.IS.thumbnail =
      this.IS.firstImage.replace("_medium", "") + "&width=300";
  },

  formatPrice(price) {
    const { currency } = this.product;
    const newPrice = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency,
      trailingZeroDisplay: "stripIfInteger",
    }).format(parseFloat(~~price));

    return newPrice.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  },

  setTopTag() {
    const { discountPercentage, tags, onSale } = this;

    const topTagTags = ["_coming soon", "out of stock", "_members only"];
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i];

      if (topTagTags.indexOf(tag) !== -1) {
        this.topTag.text = tag.replace("_", "");
        this.topTag.classes = "bg-white text-black lg";
        break;
      }
    }

    const tagIsSet = !!(this.topTag.text && this.topTag.classes);
    if (!tagIsSet && onSale && discountPercentage) {
      const saleText = "-" + ~~discountPercentage + "%";
      if (saleText != "-0%") {
        this.topTag.text = saleText;
        this.topTag.classes = "bg-black text-white border-transparent sm";
      }
    }
  },

  setTagName(tag) {
    const charToRemove = "_";
    const modifiedString = tag.replace(charToRemove, "");
    return modifiedString;
  },

  setUrl(url) {
    const parts = url.split("/");
    const lastPart = "/" + parts.slice(3).join("/");
    return lastPart;
  },

  setFirstImageClasses() {
    let classes =
      "absolute inset-0 w-full h-full object-cover object-center opacity-95";

    if (this.IS.showSecondaryImg) {
      classes = classes + " first_image ";
    }

    if (this.IS.firstImage.includes("_001.")) {
      classes = classes + " mix-blend-multiply ";
    }

    if (!this.IS.newPacshot) {
      if (this.IS.specialImage) {
        classes = classes + " scale-[0.9]";
      } else {
        classes = classes + " scale-[0.8]";
      }
    }

    return classes;
  },

  setFirstImageWrapperClasses() {
    let classes = "absolute w-full h-full bg-pacshot";

    return classes;
  },
});
